import React, { FunctionComponent, useCallback } from 'react'
import { majorScale, Pane, Button, minorScale, Text } from 'evergreen-ui'
import useCopyToClipboard from '../../../hooks/use-copy-to-clipboard'
import triggerFileDownload from '../../../lib/trigger-file-download'

const height = majorScale(4)

interface RecoveryCodeProps {
  recoveryCode: string
  onSave?: () => void
}

const RecoveryCode: FunctionComponent<RecoveryCodeProps> = props => {
  const { recoveryCode, onSave } = props

  const [isCopied, setCopied] = useCopyToClipboard(recoveryCode, { resetDelay: 3000 })

  const handleCopyClick = useCallback(() => {
    setCopied()
    if (onSave) {
      onSave()
    }
  }, [setCopied, onSave])

  const handleDownloadClick = useCallback(() => {
    triggerFileDownload(`data:text/plain;charset=utf-8,${recoveryCode}`, 'segment-recovery-code.txt')
    if (onSave) {
      onSave()
    }
  }, [recoveryCode, onSave])

  return (
    <Pane display="flex" alignItems="center">
      <Pane
        className="fullstory-exclude"
        is="code"
        display="flex"
        alignItems="center"
        height={height}
        paddingX={minorScale(3)}
        borderRadius={minorScale(1)}
        borderTopRightRadius="none"
        borderBottomRightRadius="none"
        background="tint2"
      >
        <Text color="muted">{recoveryCode}</Text>
      </Pane>
      <Button onClick={handleCopyClick} height={height} borderRadius="none">
        {isCopied ? 'Copied!' : 'Copy'}
      </Button>
      <Button
        onClick={handleDownloadClick}
        height={height}
        borderTopLeftRadius="none"
        borderBottomLeftRadius="none"
        borderLeft="none"
      >
        Download
      </Button>
    </Pane>
  )
}

export default RecoveryCode
